import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {CoursesService} from "../courses.service";

@Injectable({providedIn: 'root'})
export class CoursesResolver  {

  constructor(private coursesService: CoursesService) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Promise<any> {
    console.log('CoursesResolver');

    return new Promise<any>((resolve, reject) => {
      this.coursesService.load().subscribe(courses => {
        resolve(courses);
      }, error => {
        reject(error);
      });
    });
  }

}
